<template>
  <pt-classify-table class="pt-classify-table__withData" :tableLabels="tableLabels" @getTableData="getTableData" :tableData="tableData" v-loading="loading"
  :totalNumber="totalNumber" :pageSize="pageSize">
      <slot/>
  </pt-classify-table>
</template>

<script>
import PtClassifyTable from './index'
export default {
  name: 'pt-classify-table__withData',
  components: {
    'pt-classify-table': PtClassifyTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableData: [],
      loading: false,
      totalNumber: 0,
      pageSize: 10
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        page: page,
        size: this.pageSize

      }
      this.loading = true
      this.$store.dispatch('categoriesWithNewsCount', data).then(res => {
        this.loading = false
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取新闻分类列表失败')
      })
    }
  },
  created () {
    // this.getTableData()
  }
}
</script>
